import { Component, h, Ref } from "@lukekaalim/act";
import { MiniRenderLogic } from "../../../defs/logic/graphics";

import * as three from 'three';
import { a3 } from "@lukekaalim/act-three";
import { Mini } from "../../../defs";
import { MiniGraphicState } from "./graphics";
import { TheatreSceneResources } from "../../../hooks";
import { useDisposable } from "@kosmod/graphics-3d";

export type MiniGameMatRendererProps = {
  render: Extract<MiniRenderLogic, { renderType: 'game-mat' }>,
  res: TheatreSceneResources,
  mini: Mini,
  ref?: Ref<three.Object3D | null>,
  // graphics: MiniGraphicState,
}

const cube = new three.BoxGeometry(.1, .1, .1);
const material = new three.MeshBasicMaterial({ color: 'red' })

export const MiniGameMatRenderer: Component<MiniGameMatRendererProps> = ({
  render,
  mini,
  res,
  ref,
  // graphics,
}) => {
  const geometry = useDisposable(() => {
    return new three.PlaneGeometry(render.size.x, render.size.y, 1,  1)
      .rotateX(Math.PI / -2)
      .translate(render.size.x/2, 0, render.size.y/2)
  }, [render.size]);

  const material = useDisposable(() => {
    const texture = render.spriteId && res.miniSprites.get(render.spriteId);

    return new three.MeshBasicMaterial({
      map: texture,
      color: 'white',
      transparent: true,
    })
  }, [render.spriteId])

  return [
    h(a3.mesh, {
      ref,
      geometry,
      material,
      position: {
        x: mini.position.vector.x,
        y: 0.001,
        z: mini.position.vector.y,
      }
    }),
    h(a3.mesh, {
      geometry: cube,
      material,
      position: {
        x: mini.position.vector.x + .5,
        y: 1,
        z: mini.position.vector.y + .5,
      }
    }),
  ];
};
